import { IconActionFilters16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackNewSearchClick } from './tracking';
import { openChatbotFiltersModal } from '../../actions/chatbotFiltersModal';
import { ChatbotButton } from '../../components/ChatbotButton';

export const NewSearchButtonContainer: React.FC = () => {
  const dispatch = useDispatch();

  const onClick = React.useCallback(() => {
    trackNewSearchClick();
    dispatch(openChatbotFiltersModal());
  }, [dispatch]);

  return (
    <ChatbotButton
      onClick={onClick}
      theme="fill_white_primary"
      beforeIcon={<IconActionFilters16 color="icon-main-default" />}
    >
      Настроить поиск
    </ChatbotButton>
  );
};
